import { config } from "@/data/config";

export type SiteLogoProps = {
	className?: string;
	"aria-hidden"?: boolean;
};

/**
 * Renders `config.siteLogoSrc` when set; otherwise `config.siteLogo` (icon component).
 */
export function SiteLogo({
	className,
	"aria-hidden": ariaHidden,
}: SiteLogoProps) {
	if (config.siteLogoSrc) {
		return (
			<img
				src={config.siteLogoSrc}
				alt=""
				className={className}
				aria-hidden={ariaHidden}
				decoding="async"
				data-testid="site-logo"
			/>
		);
	}

	const Icon = config.siteLogo;
	return (
		<Icon
			className={className}
			aria-hidden={ariaHidden}
			data-testid="site-logo"
		/>
	);
}
